import { Trans } from 'react-i18next';
import './index.less';
export const NotFound = () => {
  return (
    <div className="not-found">
      <div className="not-found-404">404</div>
      <div className="not-found-text">
        <Trans i18nKey={'common.pageNotFound'} />
      </div>
    </div>
  );
};
